import React from "react";
import PhcProductInfo from "components/Product-Info-Pages/Phc/PhcProductInfo";

const Phc = () => <PhcProductInfo />;

export default Phc;
